var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeasonSpring = function SvgSeasonSpring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.579 20.754s1.219 2.495 3.27 2.308c4.158-.38 3.88-5.907 5.4-7.859a9.1 9.1 0 0 0-8.265.075c-2.154 1.216-2.307 3.27-.405 5.476m2.941-2.535s-2.7.334-4.623 5.031M5.25 18 1.5 21.75m9-3.75-3.75 3.75m14.064-11.024a7.05 7.05 0 0 0 .6-2.851 7.188 7.188 0 0 0-14.24-1.332A4.457 4.457 0 1 0 5.242 15h4.771"
  })));
};
export default SvgSeasonSpring;